import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'appcenter',
  title: '应用中心',
  routes: [
    { path: '/apps/:appCode?', name: 'apps', component: () => import('./AppView.vue'), meta: { tab: 'apps' } },
  ],
} satisfies FeatureModule
